import request from '@wearetla/tla-essentials-tools/utilities/request';
import { createI18nInstance } from '/utilities/i18n';

// Functions
import formatDate from '/functions/format-date';

const getT = () => createI18nInstance().t;

const parseLotteryItem = (item) => ({
	...item,
	created_at_formatted_date: formatDate(item.created_at, 'd.MM.yyyy'),
	created_at_formatted_time: formatDate(item.created_at, 'HH:mm'),
});

const parseLotteryPayload = (payload) => ({
	...payload,
	lottery_count: payload.lottery_count ?? 0,
	user_lottery_status: !!payload.user_lottery_status,
	// Yeniden eskiye.
	lotteries: (payload.lotteries ?? [])
		.map(parseLotteryItem)
		.sort((a, b) => `${b.created_at}`.localeCompare(`${a.created_at}`)),
});

const lotteryServices = {
	getLottery: () => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.get('user/lottery', {}, (payload, status, request) => {
				if (status === 200 && payload) {
					resolve(parseLotteryPayload(payload));
				} else {
					reject(
						request?.data?.meta?.messages ||
							t(
								'Çekiliş bilgilerin getirilirken bir hata ile karşılaşıldı, lütfen daha sonra tekrar dene.'
							)
					);
				}
			});
		});
	},
	// QR'dan okunan sipariş bilgileriyle yeni çekiliş hakkı tanımlar.
	submitOrder: ({ CompID, BrID, ModulNo, BelgeID }) => {
		const t = getT();

		return new Promise((resolve, reject) => {
			request.post(
				'user/lottery',
				{
					CompID,
					BrID,
					ModulNo,
					BelgeID,
				},
				(payload, status, request) => {
					if (status === 200) {
						resolve(
							request?.data?.meta?.messages || {
								success: t('Siparişin çekiliş haklarına eklendi.'),
							}
						);
					} else {
						reject(
							request?.data?.meta?.messages ||
								t('Siparişin çekilişe tanımlanırken bir hata ile karşılaşıldı, lütfen tekrar dene.')
						);
					}
				}
			);
		});
	},
};

export default lotteryServices;
